import { createSlice } from '@reduxjs/toolkit';
import { getRoleBasedIncidents, createIncident, updateIncident,getIncident } from '../../services/api';

const initialState = {
  incidents: [],
  loading: false,
  error: null,
  totalCount: 0,  // Add totalCount to handle pagination
};

const incidentSlice = createSlice({
  name: 'incidents',
  initialState,
  reducers: {
    setIncidents: (state, action) => {
      state.incidents = Array.isArray(action.payload) ? action.payload : [];  // Ensure it's an array
    },
    addIncident: (state, action) => {
      state.incidents.push(action.payload);
    },
    updateIncidentInState: (state, action) => {
      const index = state.incidents.findIndex((i) => i._id === action.payload._id);
      if (index !== -1) state.incidents[index] = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setIncidentRefNo: (state, action) => {
      state.incidentRefNo = action.payload;  // Add the refNo to the state
    },
    setTotalCount: (state, action) => {
      state.totalCount = action.payload; // Store the total count of incidents
    },
  },
});

export const {
  setIncidents,
  addIncident,
  updateIncidentInState,
  setLoading,
  setError,
  setIncidentRefNo, // Export the new action to set refNo
  setTotalCount,
} = incidentSlice.actions;

// Thunks
export const fetchIncidentsByRole = ({ page = 1, limit = 10, status = 'open', extraParams = {} }) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const { data } = await getRoleBasedIncidents(page, limit, status, extraParams);

    dispatch(setIncidents(data.incidents || []));
    dispatch(setTotalCount(data.totalCount || 0));

  } catch (error) {
    console.log('Error fetching incidents:', error);
    dispatch(setError(error.message));
  } finally {
    dispatch(setLoading(false));
  }
};



export const createNewIncident = (incidentData) => async (dispatch) => {
  try {
    const { data } = await createIncident(incidentData);
    const incident = data.incident || data;
    dispatch(addIncident(incident));
    return incident;
  } catch (error) {
    console.error('Failed to create incident:', error);
  }
};


export const updateIncidentDetails = (id, updateData) => async (dispatch) => {
  try {
    const { data } = await updateIncident(id, updateData);
    const incident = data.incident || data;
    if (incident?._id) {
      dispatch(updateIncidentInState(incident));
    }
    return data;
  } catch (error) {
    console.error('Failed to update incident:', error);
  }
};

export const getIncidentDetails = (id) => async () => {
  try {
    const { data } = await getIncident(id);
    return data;
  } catch (error) {
    console.error('Failed to fetch incident details:', error);
    throw error;
  }
};

export default incidentSlice.reducer;
